import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // const loginId = useSelector((state) => state.user.id);
  const loginId = localStorage.getItem('loginId');

  if (!loginId) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
